import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const MobileMenuIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="22 14 32 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Phone bezel - filled frame, screen cutout */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.5 20.3615V53.64C24.5 55.8787 26.3614 57.7008 28.6483 57.7008H47.3517C49.6386 57.7008 51.5 55.8787 51.5 53.64V20.3615C51.5 18.1229 49.6386 16.3008 47.3517 16.3008H28.6483C26.3614 16.3008 24.5 18.1229 24.5 20.3615ZM28.6483 17.923H47.3517C48.7253 17.923 49.8428 19.017 49.8428 20.3615V53.64C49.8428 54.9846 48.7253 56.0785 47.3517 56.0785H28.6483C27.2747 56.0785 26.1572 54.9846 26.1572 53.64V20.3615C26.1572 19.017 27.2747 17.923 28.6483 17.923Z"
        fill="currentColor"
      />
      {/* Screen - filled inner area */}
      <path
        d="M29.6474 22.8257C29.6474 21.874 30.4362 21.1018 31.4084 21.1018H44.5901C45.5623 21.1018 46.3511 21.874 46.3511 22.8257V45.6052C46.3511 46.5569 45.5623 47.3291 44.5901 47.3291H31.4084C30.4362 47.3291 29.6474 46.5569 29.6474 45.6052V22.8257Z"
        fill="currentColor"
      />
      {/* Home button - filled */}
      <path
        d="M38 54.2289c-1.0137 0-1.8371-.8059-1.8371-1.7984s.8234-1.7984 1.8371-1.7984 1.8371.8059 1.8371 1.7984-.8234 1.7984-1.8371 1.7984z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default MobileMenuIcon;

MobileMenuIcon.propTypes = customIconsPropTypes;
